import * as types from '../actions/session.actionTypes';

const INITIAL_STATE = {
    mixpanelUserId: null,
    user_firstname: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.UPDATE_SESSION:
            return {
                ...state,
                ...action.payload,
            };

        case types.DESTROY_SESSION:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
};
